import { useEffect } from 'react';
import { OptionSetFileValueItem } from '../option-set-file.props';

export const useCreateFirstForm = (onChange: (value: OptionSetFileValueItem[]) => void) => {
  useEffect(() => {
    onChange([{ documentType: null, files: [], id: 1 }]);
  }, []);
};
